import type { Purchase } from '@packages/domain/models/purchase';
import {
  CREATE_PAYMENT_SUCCESS,
  FETCH_PAYMENT_SUCCESS,
} from 'constants/payment';

type PurchasesAction = {
  type: typeof CREATE_PAYMENT_SUCCESS | typeof FETCH_PAYMENT_SUCCESS;
  payload: {
    entities: {
      purchases: Record<string, Purchase>;
    };
  };
};

const purchases = (
  state: Record<string, Purchase> = {},
  action: PurchasesAction,
) => {
  switch (action.type) {
    case CREATE_PAYMENT_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
      const {
        entities: { purchases = {} },
      } = action.payload;
      return { ...state, ...purchases };
    default:
      return state;
  }
};

export { purchases };
